module.exports = __webpack_public_path__ + "img/sidebar-open.f2facbfa.svg";